// /app/frontend/src/components/VisitorGate.jsx
// Permite acesso quando modo visitante está ativo, senão redireciona para login/cadastro

import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Lock, UserPlus } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function VisitorGate({ children, recurso = "esta página" }) {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [modoVisitante, setModoVisitante] = useState(null);

  useEffect(() => {
    if (user) return; // Logado - não precisa verificar
    axios.get(`${API}/api/configuracoes/modo-visitante`)
      .then(res => setModoVisitante(res.data?.ativo || false))
      .catch(() => setModoVisitante(false));
  }, [user]);

  // Usuário logado - acesso direto
  if (user) return children;

  // Carregando status
  if (modoVisitante === null) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-500" />
      </div>
    );
  }

  // Modo visitante ativo - permite acesso (somente leitura)
  if (modoVisitante) return children;

  // Modo fechado - mostrar tela de cadastro
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-lg">
        <CardContent className="pt-8 pb-6 text-center space-y-4">
          <div className="w-16 h-16 mx-auto rounded-full bg-emerald-100 flex items-center justify-center">
            <Lock className="w-8 h-8 text-emerald-600" />
          </div>
          <h2 className="text-xl font-bold text-slate-800">Acesso Restrito</h2>
          <p className="text-slate-600 text-sm">
            Para acessar {recurso}, você precisa estar cadastrado na plataforma.
          </p>
          <div className="flex flex-col gap-2 pt-2">
            <Button onClick={() => navigate('/cadastro')} className="w-full bg-emerald-600 hover:bg-emerald-700">
              <UserPlus className="w-4 h-4 mr-2" />
              Cadastre-se Grátis
            </Button>
            <Button onClick={() => navigate('/login')} variant="outline" className="w-full">
              Já tenho conta — Entrar
            </Button>
            <Link to="/" className="text-sm text-slate-500 hover:underline mt-1">
              ← Voltar ao Ranking
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
